import styled from 'styled-components';

interface ResultSectionProps {
  title: string;
  children?: React.ReactNode;
}

const SymptomResultSection = ({ title, children }: ResultSectionProps) => {
  return (
    <Wrapper>
      <SectionTitle>{title}</SectionTitle>
      {children}
    </Wrapper>
  );
};

interface ResultProps {
  children: React.ReactNode;
}

const Result = ({ children }: ResultProps) => {
  return <>{children}</>;
};

interface MoreButtonProps {
  onClick: () => void;
}

const MoreButton = ({ onClick }: MoreButtonProps) => {
  return (
    <ButtonWrapper onClick={onClick}>
      <ButtonText>더 보기</ButtonText>
    </ButtonWrapper>
  );
};

SymptomResultSection.Result = Result;
SymptomResultSection.MoreButton = MoreButton;
export default SymptomResultSection;

const Wrapper = styled.section``;

const SectionTitle = styled.span`
  display: inline-flex;
  justify-content: space-between;
  padding: 24px 24px 12px;
  align-items: center;
  ${({ theme }) => theme.typography.UI13M};
  color: ${({ theme }) => theme.color.gray600};
`;

const ButtonWrapper = styled.button`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 0px;
  margin-top: 16px;
  align-self: stretch;
  border-top: 1px solid ${({ theme }) => theme.color.gray50};
`;

const ButtonText = styled.div`
  ${({ theme }) => theme.typography.UI17R};
  color: ${({ theme }) => theme.color.gray500};
`;
